import { Dialog, Layout, Text } from '@loadsmart/miranda-react'

import { Icon } from 'core/ui/components/icon/Icon'

type BidExpiredDialogProps = {
  onClose: () => void
}

export function BidExpiredDialog({ onClose }: BidExpiredDialogProps) {
  return (
    <>
      <Dialog.Header>
        Bid expired
        <Dialog.Close onClick={onClose} data-testid="close-button" />
      </Dialog.Header>
      <Dialog.Body>
        <Layout.Stack align="center">
          <Icon name="attention" size={48} color="warning" />
          <Text>This offer has expired. Please try again</Text>
        </Layout.Stack>
      </Dialog.Body>
    </>
  )
}
